import { Table as AntTable } from 'antd';
import { TableProps as AntTableProps } from 'antd/es/table';
import { observer } from 'mobx-react-lite';

export type TableProps<T> = AntTableProps<T>;

export const Table = observer(
    <T extends Record<string, any>>({
        rowKey = 'id',
        ...props
    }: TableProps<T>) => {
        return <AntTable rowKey={rowKey} {...props} />;
    },
);
